export var Placeholder;
(function (Placeholder) {
    Placeholder["Value"] = "placeholder";
    Placeholder["Empty"] = "";
})(Placeholder || (Placeholder = {}));
export const selectSizes = ["small", "default", "large"];
//# sourceMappingURL=interfaces.js.map